interface Branch {
  id: string;
  content: string;
  type?: number;
}

const baseStyle = `
padding: 8px;
margin: 0;
cursor: pointer;
text-overflow: ellipsis;
overflow: hidden;
white-space: nowrap;
`;
const activeStyle = `
background-color: #F0F5FF;
color: #0052D9;
`;
const inactiveStyle = `
background-color: transparent;
color: #4F586B;
`;
export function createBranchMenu(
  branches: Branch[],
  edgeStartNodeBranchId?: string,
) {
  const outDiv = document.createElement("div");
  outDiv.style.cssText = `
    width: 200px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(70, 98, 140, 0.08);
    padding: 8px 0;
  `;

  outDiv.innerHTML =
    "<ul style='list-style: none; padding: 0; margin: 0;display: flex;flex-direction: column;gap: 0px;'>" +
    branches
      .map((v) => {
        const isActive = edgeStartNodeBranchId === v.id;

        return `<li
          data-edge-relation-id="${v.id}"
          data-type="${v.type || ""}"
          data-edge-relation-name="${v.content}"
          style="${baseStyle}${isActive ? activeStyle : inactiveStyle}"
          ${
            isActive
              ? ""
              : `
            onmouseover="this.style.backgroundColor='#F0F5FF'; this.style.color='#0052D9';"
            onmouseout="this.style.backgroundColor='transparent'; this.style.color='#4F586B';"
          `
          }
        >${v.content || "&nbsp;"}</li>`;
      })
      .join("") +
    "</ul>";

  return outDiv;
}
